import { CommonModule as AngularCommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { RivModule } from '@rivet-health/design-system';
import { IconsModule } from '../../common/icons/module';
import { InputModule } from '../../common/input/module';
import { CommonModule } from '../../common/module';
import { RouteService } from '../../common/state/route.service';
import { AccountIdService } from '../account/account-id.service';
import { ChangePasswordComponent } from './change-password.component';
import { CreateLoginBackgroundComponent } from './create-login-background.component';
import { CreateLoginComponent } from './create-login.component';
import { EmailSentComponent } from './email-sent.component';
import { ForgotPasswordComponent } from './forgot-password.component';
import { LoginParentComponent } from './login-parent.component';
import { LoginSSOComponent } from './login-sso.component';
import { LoginComponent, LoginGuard, LogoutGuard } from './login.component';

const routes: Routes = [
  {
    component: LoginParentComponent,
    path: '',
    data: { title: 'Login' },
    children: [
      {
        component: LoginComponent,
        canActivate: [LoginGuard],
        path: '',
        pathMatch: 'full',
        data: { title: 'Login' },
      },
      {
        component: CreateLoginComponent,
        canActivate: [LoginGuard],
        path: 'create',
        pathMatch: 'full',
        data: { title: 'Create' },
      },
      {
        component: LoginSSOComponent,
        canActivate: [LoginGuard],
        path: 'sso',
        pathMatch: 'full',
        data: { title: 'Login' },
      },
      {
        path: 'password',
        pathMatch: 'full',
        redirectTo: '',
      },
      {
        path: 'email',
        pathMatch: 'full',
        redirectTo: '',
      },
      {
        component: ForgotPasswordComponent,
        canActivate: [LogoutGuard],
        path: 'forgot',
        pathMatch: 'full',
        data: {
          title: 'Forgot password',
        },
      },
      {
        component: ChangePasswordComponent,
        canActivate: [LogoutGuard],
        path: 'reset',
        pathMatch: 'full',
        data: { title: 'Change password' },
      },
      {
        component: EmailSentComponent,
        canActivate: [LogoutGuard],
        path: 'sent',
        pathMatch: 'full',
        data: { title: 'Email sent' },
      },
    ],
  },
];

@NgModule({
  declarations: [
    ChangePasswordComponent,
    EmailSentComponent,
    LoginComponent,
    LoginSSOComponent,
    LoginParentComponent,
    ForgotPasswordComponent,
    CreateLoginComponent,
    CreateLoginBackgroundComponent,
  ],
  exports: [RouterModule],
  imports: [
    AngularCommonModule,
    CommonModule,
    FormsModule,
    IconsModule,
    InputModule,
    RivModule,
    RouterModule.forChild(routes),
  ],
  providers: [AccountIdService, RouteService],
})
export class LoginModule {}
